import React, { useEffect, useMemo } from 'react';
import { Avatar, Box, Flex } from '@chakra-ui/react';
import { MainInfo } from './mainInfo';
import { ethers } from 'ethers';
import { IGame } from '../../../providers/Games/useGames';
import { SocialsPane } from 'src/common/components/socialsPane';
import { contrastColors } from '../../../utils/parser';
import { nFormatter } from '../../../utils/utils';

export const GameOverviewHeader = ({ gameData }: { gameData: IGame }) => {
	const actionTextColor = useMemo(
		() => (contrastColors(gameData.colors.actionColor, '#ffffff') > 3.1 ? 'white' : 'black'),
		[gameData.colors.actionColor]
	);

	useEffect(() => {
		console.log(gameData);
	}, [gameData]);

	return (
		<Flex
			m={{ base: '0', hashup: '80px 0 50px 0' }}
			gridGap={{ base: '16px', hashup: '60px' }}
			flexWrap="wrap"
			justifyContent="space-between"
			zIndex="1"
		>
			<Flex
				gridGap={{ base: '16px', hashup: '60px' }}
				flexDirection={{ base: 'column', hashup: 'row' }}
				alignItems={{ base: 'center', hashup: 'unset' }}
				width="100%"
			>
				<Avatar
					borderRadius={{ base: '0', hashup: '5px' }}
					height="185px"
					minWidth={{ base: '100%', hashup: '325px' }}
					src={gameData.media.coverImageUrl ?? gameData.media.cover}
					filter={`drop-shadow(0px 0px 3.5rem ${gameData.colors.textColor}40)`}
					userSelect="none"
					//bg={gameData.colors.actionColor}
					bg="none"
					name={gameData.name.slice(0, 1)}
					color={actionTextColor}
				/>
				<Flex
					flexDirection="column"
					justifyContent="space-between"
					width="100%"
					gridGap={{ base: '16px', hashup: '0' }}
					paddingX={{ base: '12px', hashup: '0' }}
					paddingTop={{ base: '8px', hashup: '0' }}
					paddingBottom={{ base: '24px', hashup: '0' }}
				>
					<MainInfo
						account={gameData.address}
						price={`${ethers.utils.formatUnits(gameData.price, 4)}`}
						priceInHash="–– #"
						name={gameData.name}
						initialPrice={`${ethers.utils.formatUnits(gameData.price, 4)}`}
						marketCap="Soon"
						totalSupply={`${nFormatter(Number(gameData.totalSupply) / 100, 1)} ${gameData.symbol}`}
						type={gameData.color}
						priceChange={0}
						marketCapChange={0}
						symbol={gameData.symbol}
						image={gameData.media.icon ?? gameData.media.logoUrl}
						game={gameData}
						marketplaceFee={gameData.marketplaceFee}
					/>
					<Box
						gridArea="media"
						zIndex="10"
					>
						<SocialsPane
							socials={{
								discord: gameData.socials.discord,
								twitter: gameData.socials.twitter,
								fb: gameData.socials.discord,
							}}
							web={gameData.gameUrl}
							colors={gameData.colors.textColor}
						/>
					</Box>
				</Flex>
			</Flex>
		</Flex>
	);
};
